/**
 * Platform wrapper for i18next / react-i18next. App code imports `useT` and
 * the initialized instance from here (`@platform/i18n`), never from the
 * packages directly — the next i18next major touches this file only.
 */
import i18next from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import { resources, defaultLocale } from '@i18n';

void i18next.use(initReactI18next).init({
  resources,
  lng: detectLocale(),
  fallbackLng: defaultLocale,
  interpolation: { escapeValue: false },
});

function detectLocale(): string {
  const fromQuery = new URLSearchParams(window.location.search).get('locale');
  if (fromQuery && fromQuery in resources) return fromQuery;
  return defaultLocale;
}

export const i18n = i18next;
export const useT = useTranslation;
